module.exports = __webpack_public_path__ + "static/media/ice33.97204d9d.webp";